<template>
  <div class="kiw-form kiw-form--contact">
    <Webform :defaults="defaults" :cmpLibrary="cmpLibrary" id="contact" />
  </div>
</template>

<script src="./ContactForm.js"></script>
